import { useSocket } from '../contexts/SocketContext';

/**
 * Hook personalizado para acceder al contexto HTTP-only (backward compatibility).
 * Solo debe usarse dentro del cuerpo de componentes React o hooks personalizados.
 */
export const useSocketContext = () => {
  return useSocket();
};

export default useSocketContext; 